/**
 * TaskPortalAssignmentService
 * Service for task assignment operations in the portal.
 * Route: api/task-portal/tasks/{taskId}/assignments
 */
import { TaskPortalBaseService } from './TaskPortalBaseService';
/**
 * TaskPortalAssignmentService
 * Handles assignment operations for the task portal.
 * Creators: Full CRUD on assignments
 * Assignees: View only
 */
export class TaskPortalAssignmentService extends TaskPortalBaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? TaskPortalAssignmentService.DEFAULT_SERVICE_PATH,
            basePath: config?.basePath ?? TaskPortalAssignmentService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all assignments for a task
     * GET /api/task-portal/tasks/{taskId}/assignments
     */
    async getAssignments(taskId) {
        const response = await this.getAssignmentsRaw(taskId);
        return response.data ?? [];
    }
    getAssignmentsRaw(taskId) {
        return this.get(`${taskId}/assignments`);
    }
    /**
     * Assign a user to a task (creator only)
     * POST /api/task-portal/tasks/{taskId}/assignments
     */
    async assignUser(taskId, userId) {
        const response = await this.assignUserRaw(taskId, { userId });
        if (!response.data) {
            throw new Error('Failed to assign user');
        }
        return response.data;
    }
    assignUserRaw(taskId, data) {
        return this.post(`${taskId}/assignments`, data);
    }
    /**
     * Remove a user from a task (creator only)
     * DELETE /api/task-portal/tasks/{taskId}/assignments/{userId}
     */
    async removeUser(taskId, userId) {
        const response = await this.removeUserRaw(taskId, userId);
        if (!response.success) {
            throw new Error('Failed to remove user');
        }
    }
    removeUserRaw(taskId, userId) {
        return this.delete(`${taskId}/assignments/${encodeURIComponent(userId)}`);
    }
}
TaskPortalAssignmentService.DEFAULT_SERVICE_PATH = 'tasks';
TaskPortalAssignmentService.BASE_PATH = 'api/task-portal/tasks';
//# sourceMappingURL=TaskPortalAssignmentService.js.map